import { createSlice } from '@reduxjs/toolkit'

const commandSlice = createSlice({
  name: 'command',
  initialState: {
    show: false,
    name: null,
    parameters: null,
    onSubmit: null,
  },
  reducers: {
    changeCommand: (state, action) => {
      console.log(action.payload)
      state.show = action.payload.show
      state.name = action.payload.name
      state.parameters = action.payload.parameters
      state.onSubmit = action.payload.onSubmit
    }
  }
})

export const { changeCommand } = commandSlice.actions
export default commandSlice.reducer
